<script>
export default {
  name: "CardTableTechMapForCommission",
  props: {
    data_tech_map: {
      type: Array
    },
    alternative_view: {
      type: Boolean
    }
  },
  data:() => ({
    headers_table_tech_map: [
      {
        text: '№ раздела (модуля)',
        value: 'index_module',
        sortable: false,
        align: 'center',
        class: 'section-field'
      },
      {text: 'Название раздела/Темы лекций ', value: 'name', sortable: false, align: "start", filterable: false},
      {text: 'Лекция', value: 'types_lecture', align: "center", sortable: false, filterable: false},
      {text: 'Практическое занятие', value: 'types_practical_training', align: "center", sortable: false, filterable: false},
      {text: 'Лабораторная работа', value: 'types_laboratory_work', sortable: false, align: "center", filterable: false},
      {text: 'СРС', value: 'types_students_independent_work', sortable: false, align: "center", filterable: false},
      {text: 'Контроль', value: 'types_final_control', sortable: false, align: "center", filterable: false},
    ],
    areas_training: ['Зачет', 'Экзамен', 'Зачет с оценкой', 'Курсовая работа', 'Защита ВКР']
  })

}
</script>

<template>
  <v-data-table
      :headers="headers_table_tech_map"
      :items="data_tech_map"
      no-data-text="Данные курса отсутствуют"
      fixed-header
      disable-pagination
      height="100%"
      mobile-breakpoint="0"
      hide-default-footer
  >
    <template v-slot:body="{ items, headers }">
      <tbody v-if="alternative_view">
        <template v-for="(parent_module, index_parent_module) in items">
        <tr :key="index_parent_module">
          <td :class="headers_table_tech_map[0].class" class="text-center">{{ index_parent_module + 1 }}</td>
          <template v-if="areas_training.includes(parent_module.name)">
            <td :class="headers_table_tech_map[0].class">{{ parent_module.name }}</td>
            <td v-for="(i, index) in 4" :key="index" :class="headers_table_tech_map[0].class"/>
            <td>
              <v-chip-group column>
                <v-chip
                    v-for="(type_lecture, index) in parent_module.types_final_control" :key="index"
                    outlined
                >
                  {{ type_lecture }}
                </v-chip>
              </v-chip-group>
            </td>
          </template>
          <template v-else>
            <td colspan="6" :class="headers_table_tech_map[0].class">{{ parent_module.name }}</td>
          </template>
        </tr>
        <tr v-for="(child_module, index_child_module) in parent_module.items">
          <td :class="headers_table_tech_map[0].class">{{ child_module.index_module }}</td>
          <td :class="headers_table_tech_map[0].class">{{ child_module.name }}</td>
          <td :class="headers_table_tech_map[0].class">
            <v-chip-group column>
              <v-chip
                  v-for="(type_lecture, index) in child_module.types_lecture" :key="index"
                  outlined
              >
                {{ type_lecture }}
              </v-chip>
            </v-chip-group>
          </td>
          <td :class="headers_table_tech_map[0].class">
            <v-chip-group column>
              <v-chip
                  v-for="(type_lecture, index) in child_module.types_practical_training" :key="index"
                  outlined
              >
                {{ type_lecture }}
              </v-chip>
            </v-chip-group>
          </td>
          <td :class="headers_table_tech_map[0].class">
            <v-chip-group column>
              <v-chip
                  v-for="(type_lecture, index) in child_module.types_laboratory_work" :key="index"
                  outlined
              >
                {{ type_lecture }}
              </v-chip>
            </v-chip-group>
          </td>
          <td :class="headers_table_tech_map[0].class">
            <v-chip-group column>
              <v-chip
                  v-for="(type_lecture, index) in child_module.types_students_independent_work" :key="index"
                  outlined
              >
                {{ type_lecture }}
              </v-chip>
            </v-chip-group>
          </td>
          <td>
            <v-chip-group column>
              <v-chip
                  v-for="(type_lecture, index) in child_module.types_final_control" :key="index"
                  outlined
              >
                {{ type_lecture }}
              </v-chip>
            </v-chip-group>
          </td>
        </tr>
      </template>
      </tbody>
      <tbody v-else>
        <template v-for="(parent_module, index_parent_module) in items">
        <tr :key="index_parent_module">
          <td :class="headers_table_tech_map[0].class" class="text-center">{{ index_parent_module + 1 }}</td>
          <td :class="headers_table_tech_map[0].class">{{ parent_module.name }}</td>
          <td :class="headers_table_tech_map[0].class">
            <v-chip-group column>
              <v-chip
                  v-for="(type_lecture, index) in parent_module.types_lecture" :key="index"
                  outlined
              >
                {{ type_lecture }}
              </v-chip>
            </v-chip-group>
          </td>
          <td :class="headers_table_tech_map[0].class">
            <v-chip-group column>
              <v-chip
                  v-for="(type_lecture, index) in parent_module.types_practical_training" :key="index"
                  outlined
              >
                {{ type_lecture }}
              </v-chip>
            </v-chip-group>
          </td>
          <td :class="headers_table_tech_map[0].class">
            <v-chip-group column>
              <v-chip
                  v-for="(type_lecture, index) in parent_module.types_laboratory_work" :key="index"
                  outlined
              >
                {{ type_lecture }}
              </v-chip>
            </v-chip-group>
          </td>
          <td :class="headers_table_tech_map[0].class">
            <v-chip-group column>
              <v-chip
                  v-for="(type_lecture, index) in parent_module.types_students_independent_work" :key="index"
                  outlined
              >
                {{ type_lecture }}
              </v-chip>
            </v-chip-group>
          </td>
          <td>
            <v-chip-group column>
              <v-chip
                  v-for="(type_lecture, index) in parent_module.types_final_control" :key="index"
                  outlined
              >
                {{ type_lecture }}
              </v-chip>
            </v-chip-group>
          </td>
        </tr>
      </template>
      </tbody>
    </template>
  </v-data-table>
</template>

<style scoped>
  .section-field{
    border-right: 1px solid rgba(0, 0, 0, 0.12);
  }

</style>